import API from '@Services/apiAxios';
import axios from 'axios';
import { ParsedExcelData } from './excelParser';

export const uploadExcelData = async (
  parsedData: ParsedExcelData,
  orgCode: string,
  sessionId?: string,
): Promise<any> => {
  const requestHeaders: Record<string, string> = {
    org_code: orgCode,
  };
  if (sessionId) {
    requestHeaders['sessionId'] = sessionId;
  }

  const response = await API.post('/speedboxbot/extract/excel', parsedData, {
    headers: requestHeaders,
  });
  return response.data;
};

export const uploadAttachment = async (
  file: File,
  onUploadProgress?: (percent: number) => void,
): Promise<string | null> => {
  const { data } = await API.post('/speedboxbot/extract/upload-url', {
    fileName: file.name,
    mimeType: file.type,
  });

  const { uploadUrl, s3Key } = data;

  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: progressEvent => {
      if (onUploadProgress) {
        const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
        onUploadProgress(percent);
      }
    },
  });

  return s3Key;
};
